<script>
  import '@awesome.me/webawesome-pro/dist/components/input/input.js';
  import '@awesome.me/webawesome-pro/dist/components/button/button.js';
  import '@awesome.me/webawesome-pro/dist/components/select/select.js';
  import '@awesome.me/webawesome-pro/dist/components/option/option.js';
  import { categoryState } from '#state/categories';

  let selectedCategory = $state("-1");

  function handleCategoryChange(e) {
    selectedCategory = e.target.value;
  }
</script>

<aside class="app-sidebar">
  <h3>Filters</h3>

  <div class="filter-group">
    <wa-input label="Search Text" placeholder="e.g. platformer controller"></wa-input>
  </div>

  <div class="filter-group">
    <wa-select
      label="Category"
      value={selectedCategory}
      onwa-change={handleCategoryChange}
    >
      <wa-option value="-1">All Categories</wa-option>

      {#if categoryState.list !== null && categoryState.list !== undefined && categoryState.list.length > 0}
        {#each categoryState.list as cat (cat.id)}
          <wa-option value={cat.id}>{cat.name}</wa-option>
        {/each}
      {/if}
    </wa-select>
  </div>

  <div class="filter-group">
    <wa-button variant="neutral" outline>Apply Filters</wa-button>
  </div>
</aside>

<style>
  h3 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
    font-weight: 600;
  }
  .filter-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
</style>